interface IProps {
    width?: number;
    height?: number;
}

export const PrevIcon = (props: IProps) => {
    const {width, height} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || 16}
            height={height || 18}
            viewBox="0 0 16 18"
            fill="none"
        >
            <path
                d="M3 0.686157H0.5V17.3528H3V10.1362L15.5 17.3528V0.686157L3 7.90281V0.686157Z"
                fill="#FCFCFC"
            />
        </svg>
    );
};
